import { T }    from 'defa-object';
/**
 * defa.views.SubscriptionTerminateVerificationForm
 * A form for verifying subscription termination.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/subscriptionTerminateVerificationForm.jst.html';

const selectors = {
	ending: '[data-choice=%s]',
};

const SubscriptionTerminateVerificationForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	templateContext: function () {
		return {
			ending     : this.options.ending,
			unitType   : this.model.getUnitType(),
			renewalDate: this.getRenewalDate(),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view is shown.
	 * @void
	 */
	//onRender: function () {
		
		//let choiceSelector = selectors.ending.replace( '%s', this.options.ending );
		//$( choiceSelector ).removeClass( 'hidden' );
	//},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets the date-formatted renewal date.
	 * @return {string} Translated human readable date formatted version of the validFrom date.
	 */
	getRenewalDate: function () {
		let date = new Date( this.model.get( 'transientExpirationDate' ) );
		return date.format( T.dateFormatShort );
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		this.trigger( 'terminate' );
	},
	
} );

export default SubscriptionTerminateVerificationForm;